new Swiper('.insta-slider', {
   autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
     breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: 20,
        },
       580: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
       767: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
        1400: {
          slidesPerView: 5,
          spaceBetween: 30,
        },
     },
});